// Last answers of a few public, anonymous shop-wide reads (store details,
// delivery zones, payment methods for shop copy, the live campaign, the
// assistant switch, the footer's app links), kept in localStorage for FACTS_MAX_AGE_MS so the next
// page load can paint with them at once while the fresh answer loads in the
// background (stale-while-revalidate). Never for anything user-specific, and
// never read by checkout: it always asks GET /payments/methods fresh
// (utils/paymentMethods.fetchPaymentMethods is only ever a writer here).
// Storage may be blocked or full: every access is wrapped, a miss is normal.

const PREFIX = 'anum_facts:';
export const FACTS_MAX_AGE_MS = 10 * 60 * 1000;

export const FACTS = Object.freeze({
  store: 'store',
  zones: 'zones',
  payments: 'payments',
  campaign: 'campaign',
  concierge: 'concierge',
  appLinks: 'app_links',
});

const NAMES = new Set(Object.values(FACTS));

/** The raw answer stored for `name`, or `undefined` (none, too old, unreadable). */
export const readFacts = (name, { now = Date.now(), maxAgeMs = FACTS_MAX_AGE_MS } = {}) => {
  if (!NAMES.has(name)) return undefined;
  try {
    const entry = JSON.parse(window.localStorage.getItem(PREFIX + name) || 'null');
    if (!entry || typeof entry !== 'object' || typeof entry.at !== 'number' || !('v' in entry)) return undefined;
    // Too old, or written "in the future" (clock changed): not trusted.
    if (now - entry.at > maxAgeMs || entry.at - now > 60000) return undefined;
    return entry.v;
  } catch {
    return undefined;
  }
};

/** Remember a successful raw answer for `name`. Errors are ignored. */
export const writeFacts = (name, value, { now = Date.now() } = {}) => {
  if (!NAMES.has(name) || value === undefined) return;
  try {
    window.localStorage.setItem(PREFIX + name, JSON.stringify({ at: now, v: value }));
  } catch { /* storage blocked or full: only a speed-up */ }
};
